import { render, staticRenderFns } from "./PDFButton.vue?vue&type=template&id=e10d053a&scoped=true"
import script from "./PDFButton.vue?vue&type=script&lang=ts"
export * from "./PDFButton.vue?vue&type=script&lang=ts"
import style0 from "./PDFButton.vue?vue&type=style&index=0&id=e10d053a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10d053a",
  null
  
)

export default component.exports